import { InjectionToken, TemplateRef, WritableSignal } from '@angular/core';

/** What a composer projected as the panel's body shows between the scrolling body and the footer. */
export interface PathFilterPanelPin {
  phrase: WritableSignal<TemplateRef<unknown> | null>;
}

export const PATH_FILTER_PANEL_PIN = new InjectionToken<PathFilterPanelPin>(
  'PATH_FILTER_PANEL_PIN'
);
